import React from 'react';
import styles from './PageContentWrapper.scss';

const PageContentWrapper: React.StatelessComponent = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default PageContentWrapper;



// WEBPACK FOOTER //
// ./src/components/Page/PageContentWrapper/PageContentWrapper.tsx